import * as React from 'react';

import { Skeleton } from 'antd';
import { Column, Row, Space, Text } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { FlexAvatar, NameText } from 'components';
import { env } from 'env';
import { selectAppState } from 'slice';
import { IMAGETYPE } from 'utils';
import { formatImageUrl, getBase64Image } from 'utils/function';

import Paragraph from '../components/Paragraph';
import { CQRCode, WrapperContent } from './styles';

interface DeliveryBillContentProps {
  order: any;
  isLoading: boolean;
  onCreateImage?: () => void;
  padding?: string;
}

const DeliveryBillContent = ({
  order,
  isLoading,
  onCreateImage,
  padding,
}: DeliveryBillContentProps): JSX.Element => {
  const app = useAppSelector(selectAppState);
  const [orderInfo, setOrderInfo] = React.useState<any>({});

  const handleLoadImage = () => {
    setTimeout(() => {
      const imageSource: HTMLImageElement | null = document.getElementById(
        `imageSource-${order.code}`
      ) as HTMLImageElement;

      const imageResult: HTMLImageElement | null = document.getElementById(
        `imageResult-${order.code}`
      ) as HTMLImageElement;

      if (imageSource && imageResult) {
        imageResult.src = getBase64Image(imageSource);
      }
    }, 1);
  };

  const handleUpdateData = (val: any) => {
    if (typeof val === 'object' && val !== null) {
      setOrderInfo((prevState: any) => {
        return {
          ...prevState,
          ...val,
        };
      });
      onCreateImage && onCreateImage();
    }
  };

  const handleClearData = (e: any, val: any) => {
    e.stopPropagation();
    if (typeof val === 'object' && val !== null) {
      setOrderInfo((prevState: any) => {
        return {
          ...prevState,
          ...val,
        };
      });
    }
  };

  return (
    <WrapperContent className="bill-content" padding={padding}>
      <Row
        alignItems="center"
        justifyContent="space-between"
        styles={{
          borderBottom: '1px dashed #000000',
          padding: '0px 0px 24px',
        }}
        width="100%"
      >
        <Column styles={{ gap: 6 }} width="100%">
          {isLoading ? (
            <>
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
            </>
          ) : (
            <>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{
                    display: 'block',
                    width: 120,
                    flexShrink: 0,
                    textAlign: 'left !important',
                  }}
                  weight="bold"
                >
                  Người gửi:
                </Text>
                <Paragraph
                  align="left !important"
                  size="sm"
                  weight="extraBold"
                  onSubmit={(e: any) => {
                    handleUpdateData({ supplierName: e });
                  }}
                >
                  {/* {orderInfo?.supplierName ?? order.supplier?.displayName} */}
                  {orderInfo?.supplierName ?? order.deliveryName}
                </Paragraph>
              </Row>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{
                    width: 120,
                    flexShrink: 0,
                    textAlign: 'left !important',
                  }}
                  weight="bold"
                >
                  Địa chỉ:
                </Text>
                <Paragraph
                  align="left !important"
                  onSubmit={(e: any) => {
                    handleUpdateData({ supplierAddress: e });
                  }}
                >
                  {/* {orderInfo?.supplierAddress ??
                    getFullAddress(
                      order.supplier?.address,
                      order.supplier?.ward?.district?.fullName,
                      order.supplier?.ward?.province?.fullName,
                      order.supplier?.ward?.fullName
                    )} */}
                  {orderInfo?.supplierAddress ?? order.deliveryAddress}
                </Paragraph>
              </Row>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{
                    width: 120,
                    flexShrink: 0,
                    textAlign: 'left !important',
                  }}
                  weight="bold"
                >
                  Số điện thoại:
                </Text>
                <Paragraph
                  align="left !important"
                  onSubmit={(e: any) => {
                    handleUpdateData({ supplierPhoneNumber: e });
                  }}
                >
                  {/* {orderInfo?.supplierPhoneNumber ??
                    formatAppearPhoneNumber(order?.supplier?.phoneNumber)} */}
                  {orderInfo?.supplierPhoneNumber ?? order.deliveryPhoneNumber}
                </Paragraph>
              </Row>
            </>
          )}
        </Column>
        <Column
          alignItems="center"
          styles={{ flexShrink: 0 }}
          width="fit-content"
        >
          {isLoading ? (
            <Skeleton.Input style={{ width: 92, height: 92 }} />
          ) : (
            order?.deliveryAvatar && (
              <>
                <img
                  alt="avatar"
                  crossOrigin="anonymous"
                  id={`imageSource-${order.code}`}
                  src={formatImageUrl(
                    String(order?.deliveryAvatar),
                    IMAGETYPE.AVATAR.xs,
                    true
                  )}
                  style={{
                    display: 'none',
                    maxHeight: 84,
                    maxWidth: 168,
                  }}
                  onLoad={handleLoadImage}
                />
                <FlexAvatar
                  alt="avatar"
                  crossOrigin="anonymous"
                  id={`imageResult-${order.code}`}
                  maxHeight="84px"
                  maxWidth="168px"
                  src={formatImageUrl(
                    String(order?.deliveryAvatar),
                    IMAGETYPE.AVATAR.xxs,
                    true
                  )}
                />
              </>
            )
          )}
        </Column>
      </Row>
      <Row
        alignItems="center"
        justifyContent="space-between"
        styles={{ borderBottom: '1px dashed #000000', padding: '24px 0px' }}
        width="100%"
      >
        <Column styles={{ gap: 6 }} width="100%">
          {isLoading ? (
            <>
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
            </>
          ) : (
            <>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{
                    width: 120,
                    flexShrink: 0,
                    textAlign: 'left !important',
                  }}
                  weight="bold"
                >
                  Người nhận:
                </Text>
                <Paragraph
                  size="sm"
                  weight="extraBold"
                  onSubmit={(e: any) => {
                    handleUpdateData({ receiveName: e });
                  }}
                >
                  {/* {orderInfo?.receiveName ??
                    order.additionalInfo?.address?.title} */}
                  {orderInfo?.receiveName ?? order.receiveName}
                </Paragraph>
              </Row>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{
                    width: 120,
                    flexShrink: 0,
                    textAlign: 'left !important',
                  }}
                  weight="bold"
                >
                  Địa chỉ:
                </Text>
                <Paragraph
                  color="black"
                  onSubmit={(e: any) => {
                    handleUpdateData({ receiveAddress: e });
                  }}
                >
                  {/* {orderInfo?.receiveAddress ??
                    getFullAddress(
                      order.additionalInfo?.address?.address,
                      order.additionalInfo?.address?.district?.fullName,
                      order.additionalInfo?.address?.province?.fullName,
                      order.additionalInfo?.address?.ward?.fullName
                    )} */}
                  {orderInfo?.receiveAddress ?? order.receiveAddress}
                </Paragraph>
              </Row>
              <Row alignItems="flex-start" styles={{ gap: 6 }} width="100%">
                <Text
                  color="black"
                  lineHeight="24px"
                  styles={{ width: 120, flexShrink: 0, textAlign: 'left' }}
                  weight="bold"
                >
                  Số điện thoại:
                </Text>
                <Paragraph
                  color="black"
                  onSubmit={(e: any) => {
                    handleUpdateData({ receivePhoneNumber: e });
                  }}
                >
                  {/* {orderInfo?.receivePhoneNumber ??
                    formatAppearPhoneNumber(
                      order.additionalInfo?.address?.phoneNumber
                    )} */}
                  {orderInfo?.receivePhoneNumber ?? order.receivePhoneNumber}
                </Paragraph>
              </Row>
            </>
          )}
        </Column>
        <Column alignItems="center" styles={{ flexShrink: 0 }} width="120px">
          {isLoading ? (
            <>
              <Skeleton.Input style={{ width: 92, height: 92 }} />
              <Space height={4} />
              <Skeleton.Input size="small" style={{ width: 92 }} />
            </>
          ) : (
            <>
              <CQRCode
                level="L"
                renderAs="svg"
                value={`${
                  app?.domains?.hubBilling?.domain ??
                  env.service.hubbillingWebApp
                }/${order.code}`}
              />
              <Space height={4} />
              <NameText
                color="black"
                lineHeight="18px"
                lineNumber={2}
                size="tiny"
                styles={{ 'text-align': 'center' }}
                weight="bold"
              >
                Mã thông tin hóa đơn
              </NameText>
            </>
          )}
        </Column>
      </Row>
      <Space height={36} />
      <Column alignItems="center" styles={{ gap: 2 }} width="100%">
        {isLoading ? (
          <>
            <>
              <Skeleton.Input
                size="small"
                style={{ width: '160px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '160px', alignItems: 'center' }}
              />
              <Space height={3} />
              <Skeleton.Input
                size="small"
                style={{ width: '120px', alignItems: 'center' }}
              />
            </>
          </>
        ) : (
          <>
            <Text
              color="black"
              styles={{ 'text-align': 'center', display: 'block' }}
            >
              Tài xế gọi điện cho khách hàng ít nhất 30 phút trước khi xe tới
              bến
            </Text>
            <Text
              color="black"
              styles={{ 'text-align': 'center', display: 'block' }}
              weight="extraBold"
            >
              KHÔNG ĐỂ VẬT NẶNG LÊN THÙNG, HÀNG DỄ VỠ XIN NHẸ TAY
            </Text>
            <Text
              color="black"
              styles={{ 'text-align': 'center', display: 'block' }}
            >
              Xin cảm ơn!
            </Text>
          </>
        )}
      </Column>
    </WrapperContent>
  );
};

export default DeliveryBillContent;
